import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle, faTimes } from "@fortawesome/pro-light-svg-icons";
import { useLocation } from "react-router";
import { getHelpForPath } from "./helpContent";

// Painel de ajuda lateral: botao flutuante "?" que abre um manual
// ocupando 1/4 da tela a direita, por cima da pagina (sem desloca-la).
function HelpPanel() {
  const [open, setOpen] = React.useState(false);
  const location = useLocation();
  const help = getHelpForPath(location.pathname);

  return (
    <>
      <FloatingButton onClick={() => setOpen(true)} aria-label="Ajuda">
        <FontAwesomeIcon icon={faQuestionCircle} />
        <span>Ajuda</span>
      </FloatingButton>

      {open && (
        <Panel role="complementary" aria-label="Manual da página">
          <Head>
            <Heading>{help.title}</Heading>
            <CloseButton onClick={() => setOpen(false)} aria-label="Fechar">
              <FontAwesomeIcon icon={faTimes} />
            </CloseButton>
          </Head>
          <Body>
            <Intro>Manual de uso desta página.</Intro>
            {help.sections.map((section, i) => (
              <Section key={i}>
                {section.heading && <SectionTitle>{section.heading}</SectionTitle>}
                <List>
                  {section.items.map((item, j) => (
                    <li key={j}>{item}</li>
                  ))}
                </List>
              </Section>
            ))}
          </Body>
        </Panel>
      )}
    </>
  );
}

const FloatingButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  padding: 10px 18px;
  background-color: #007bff;
  border: none;
  border-radius: 5px;
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 1090;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  animation: helpPulse 2s infinite;
  @keyframes helpPulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.05);
    }
    100% {
      transform: scale(1);
    }
  }
`;

const Panel = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  width: 25%;
  min-width: 320px;
  max-width: 480px;
  background-color: #fff;
  z-index: 1100;
  box-shadow: -4px 0 18px rgba(0, 0, 0, 0.18);
  display: flex;
  flex-direction: column;
  @media (max-width: 768px) {
    width: 90%;
    min-width: 0;
  }
`;

const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background-color: #007bff;
  color: #fff;
`;

const Heading = styled.h2`
  font-size: 18px;
  font-weight: 600;
  margin: 0;
`;

const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  line-height: 1;
  padding: 0 4px;
`;

const Body = styled.div`
  padding: 20px;
  overflow-y: auto;
  flex: 1;
`;

const Intro = styled.p`
  color: #888;
  font-size: 13px;
  margin-bottom: 16px;
`;

const Section = styled.div`
  margin-bottom: 20px;
`;

const SectionTitle = styled.h3`
  font-size: 15px;
  font-weight: 600;
  color: #333;
  margin: 0 0 8px;
`;

const List = styled.ul`
  margin: 0;
  padding-left: 18px;
  color: #555;
  font-size: 14px;
  line-height: 1.6;
  li {
    margin-bottom: 6px;
  }
`;

export default HelpPanel;
